import {apiFetch} from '../_helpers';


export const storesService = {
    getAll,
    getAllResume,
};


function getAll() {
    return apiFetch("stores/");
}


function getAllResume() {
    return apiFetch("storesresume/");
}